module.exports = __webpack_public_path__ + "static/media/hams-hall-map-cropped.d7cd24fd.jpg";